export const TAB_HIT_PADDING_X = 8;

export type IndicatorRect = { left: number; width: number };

export const formatTransform = (rect: IndicatorRect) =>
  `translate3d(${rect.left}px, 0, 0) scaleX(${rect.width})`;

export const measureLabelRect = (tab: HTMLAnchorElement): IndicatorRect => ({
  left: tab.offsetLeft + TAB_HIT_PADDING_X,
  width: tab.offsetWidth - TAB_HIT_PADDING_X * 2,
});
